/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const EmployeeId56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue10}
                d="M22 40a6 6 0 110 12 6 6 0 010-12zM44 4c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M46.621 13.6c-.174-1.01-1.055-1.684-1.996-1.591l-.141.02L6.54 18.88c-.957.173-1.628 1.096-1.53 2.11l.02.153L9.38 46.4c.174 1.01 1.055 1.684 1.996 1.591l.141-.02L49.46 41.12c.957-.173 1.628-1.096 1.53-2.11l-.02-.153L46.62 13.6z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M48.592 13.261l4.349 25.256c.37 2.146-1.03 4.193-3.126 4.571L11.871 49.94c-2.095.379-4.093-1.054-4.463-3.2L3.059 21.483c-.37-2.146 1.03-4.193 3.126-4.571l37.944-6.851c2.095-.379 4.093 1.054 4.463 3.2zm-1.971.34c-.174-1.011-1.055-1.685-1.996-1.592l-.141.02L6.54 18.88c-.957.173-1.628 1.096-1.53 2.11l.02.153L9.38 46.4c.174 1.01 1.055 1.684 1.996 1.591l.141-.02L49.46 41.12c.957-.173 1.628-1.096 1.53-2.11l-.02-.153L46.62 13.6z"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M46 15H10a2.001 2.001 0 00-1.995 1.85L8 17v26c0 1.054.816 1.918 1.85 1.995L10 45h36a2.001 2.001 0 001.995-1.85L48 43V17a2.001 2.001 0 00-1.85-1.995L46 15z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M10 13c-2.21 0-4 1.79-4 4v26c0 2.21 1.79 4 4 4h36c2.21 0 4-1.79 4-4V17c0-2.21-1.79-4-4-4H10zm0 2h36c1.054 0 1.918.816 1.995 1.85L48 17v26a2.001 2.001 0 01-1.85 1.995L46 45H10a2.001 2.001 0 01-1.995-1.85L8 43V17c0-1.054.816-1.918 1.85-1.995L10 15z"
            />
            <path
                fill={vars.bdlBoxBlue}
                d="M20 25a3.999 3.999 0 012.843 6.813c1.584.966 2.76 2.72 3.141 4.832l.093.515-.37.37C24.132 39.103 22.123 40 20 40c-2.124 0-4.133-.897-5.707-2.47l-.37-.37.093-.515c.381-2.11 1.556-3.866 3.14-4.834A3.999 3.999 0 0120 25zm0 8c-1.71 0-3.251 1.338-3.852 3.318l-.046.163.044.04c1.053.89 2.289 1.407 3.577 1.472L20 38c1.387 0 2.725-.524 3.853-1.48l.044-.039-.045-.163c-.579-1.906-2.029-3.218-3.663-3.313zm17.5 1a.5.5 0 010 1h-7a.5.5 0 010-1h7zm4-3a.5.5 0 010 1h-11a.5.5 0 010-1h11zM20 27a2 2 0 10-.001 3.999A2 2 0 0020 27zm21.5 1a.5.5 0 010 1h-11a.5.5 0 010-1h11z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M20 33l.189.005c1.634.095 3.084 1.407 3.663 3.313l.045.163-.044.04C22.725 37.475 21.387 38 20 38l-.277-.007c-1.288-.065-2.524-.581-3.577-1.473l-.044-.039.046-.163C16.748 34.338 18.29 33 20 33zm0-6a2 2 0 11.001 3.999A2 2 0 0120 27zm8-19a3 3 0 00-2.995 2.824L25 11v7h6v-7a3 3 0 00-2.824-2.995L28 8z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M28 6a5 5 0 015 5v8h2.5a.5.5 0 010 1h-15a.5.5 0 010-1H23v-8a5 5 0 015-5zm0 2a3 3 0 00-2.995 2.824L25 11v7h6v-7a3 3 0 00-2.824-2.995L28 8zm0 2a1 1 0 110 2 1 1 0 010-2z"
            />
        </g>
    </AccessibleSVG>
);

export default EmployeeId56;
